// extracted by mini-css-extract-plugin
export default {"innerWrapper":"mt-z","tooltipWrapper":"nt-z","icon":"ot-z","tooltip":"pt-z","content":"qt-z"};